module.exports = __webpack_public_path__ + "img/save.c98b41d1.png";